import { render, staticRenderFns } from "./infinityScrollList.vue?vue&type=template&id=59c712aa&scoped=true&"
import script from "./infinityScrollList.vue?vue&type=script&lang=js&"
export * from "./infinityScrollList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c712aa",
  null
  
)

export default component.exports